import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  MarkMaintenanceRequestAsMissed,
  MarkMaintenanceRequestAsMissedVariables,
} from '../../../athena/types/MarkMaintenanceRequestAsMissed';

export const MUTATION = gql`
  mutation MarkMaintenanceRequestAsMissed($maintenanceRequestId: String!) {
    webMaintenance {
      markMaintenanceRequestAsMissed(input: { maintenanceRequestId: $maintenanceRequestId }) {
        _empty
      }
    }
  }
`;

export const useMarkMaintenanceRequestAsMissed = () => {
  return useMutation<MarkMaintenanceRequestAsMissed, MarkMaintenanceRequestAsMissedVariables>(
    MUTATION,
  );
};
